/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://fb72djwrb5fk3ndpyqlli3nvme.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cloud_logic_custom": [
        {
            "name": "jarscideronlineshopcheckout",
            "endpoint": "https://0vexitdiwd.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:655caf20-c37a-4169-a3f3-047c5eeff370",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_k9hBWRFI3",
    "aws_user_pools_web_client_id": "4omq8vlk1ikf07b1evpvsluiag",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "jarscideronlineshop-storage32555-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
